// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notyf {
    font-family: 'IBM', monospace;
    font-size: 22px;
    z-index: 100;
    filter: blur(1px);
}

.notyf .notyf-info {
    background-color: #cec9b5;
    color: black;
}

.notyf__wrapper {
    padding-right: 0 !important;
}

.notyf .notyf__message button {
    font-size: inherit;
    background: #ffaa2a;
    color: black;
    cursor: pointer;
    margin: 0;
    padding: 0 5px;
    border: none;
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/notyf.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,SAAS;IACT,cAAc;IACd,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".notyf {\n    font-family: 'IBM', monospace;\n    font-size: 22px;\n    z-index: 100;\n    filter: blur(1px);\n}\n\n.notyf .notyf-info {\n    background-color: #cec9b5;\n    color: black;\n}\n\n.notyf__wrapper {\n    padding-right: 0 !important;\n}\n\n.notyf .notyf__message button {\n    font-size: inherit;\n    background: #ffaa2a;\n    color: black;\n    cursor: pointer;\n    margin: 0;\n    padding: 0 5px;\n    border: none;\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
